module.exports = __webpack_public_path__ + "static/media/logo.4fb89fa9.png";